import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const cancelChargeApi = createAsyncThunk(
  "spotGoldCancel",
  async (productIds) => {
    const payload = {
      id: productIds,
    };
    const response = await axiosInstance.post("/merchant/cancel_Order", payload);
    return response.data;
  }
);

const cancelChargeSlice = createSlice({
  name: "spotGoldCancel",
  initialState: {
    data: [],
    errors: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(cancelChargeApi.pending, (state) => {
        state.status = "loading";
      })
      .addCase(cancelChargeApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "idle";
      })
      .addCase(cancelChargeApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.status = "idle";
      });
  },
});

export default cancelChargeSlice.reducer;
